export default "__VITE_ASSET__657MtxH6__"